const maxWidth = '1920px';
export default maxWidth;